import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import ToolsHelper from '@core/services/tools.helper';
import { SubscriptionCategory } from '@subscriptions/interfaces/subscription-category';
import { Subscription } from '@subscriptions/interfaces/subscription';
import moment from 'moment';

library.add(faPlus);

@Component({
  name: 'bpc-subscription-confirmed-modal',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class SubscriptionConfirmedModal extends Vue {
  @Prop(Object) readonly subscriptionCategory: SubscriptionCategory;
  @Prop(Array) readonly subscriptions: Subscription[];

  public config: any = {
    id: 'subscription-confirmed-modal',
    title: this.$t('global.modals.subscription_categories.subscription_confirmed'),
  };

  onOpenModal() {
    this.$bvModal.show(this.config.id);
  }
  onCloseModal() {
    this.$bvModal.hide(this.config.id);
    this.$emit('click-on-close');
  }

  get totalPrice() {
    let totalPrice = 0;
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        totalPrice += subscription.order ? subscription.order.total_price : null;
      });
    }
    return totalPrice;
  }
  public formatPrice(value: string) {
    return ToolsHelper.formatPrice(value);
  }
}
